module.exports = __webpack_public_path__ + "static/media/bell-icon.330f35e3.svg";